const iconRegistry = {
    Waveform: ()=>import("./icons/Waveform.js"),
    Sparkle: ()=>import("./icons/Sparkle.js"),
    PricelineP: ()=>import("./icons/PricelineP.js"),
    Penny: ()=>import("./icons/Penny.js"),
    Hotel: ()=>import("./icons/Hotel.js"),
    Disney: ()=>import("./icons/Disney.js"),
    DiscountFill: ()=>import("./icons/DiscountFill.js"),
    Discount: ()=>import("./icons/Discount.js"),
    AiSearch: ()=>import("./icons/AiSearch.js")
};
export { iconRegistry };
